import React from 'react';

const DespesaReceitaContext = React.createContext();

export default DespesaReceitaContext;
